(function () {
  // Get the common ancestor element for all checkboxes
  const ancestor = document.querySelector("body");

  // Add event listener to the ancestor element
  ancestor.addEventListener("change", function (event) {
    const checkbox = event.target;

    if (checkbox.matches('.fieldWrapper_is_selected input[type="checkbox"]')) {
      const parent = checkbox.closest(".has-selected-field");

      // Set both values - "true" for backend and "checked" for frontend
      if (checkbox.checked) {
        checkbox.value = "true"; // For backend
        checkbox.setAttribute("checked", "checked"); // For frontend styling
      } else {
        checkbox.value = ""; // Clear value for backend
        checkbox.removeAttribute("checked"); // For frontend styling
      }

      updateParentSelection(parent, checkbox.checked);
    }
  });

  // Check checkboxes on page load
  window.addEventListener("load", function () {
    const checkboxes = document.querySelectorAll(
      '.fieldWrapper_is_selected input[type="checkbox"]'
    );

    checkboxes.forEach(function (checkbox) {
      const parent = checkbox.closest(".has-selected-field");
      if (checkbox.checked) {
        checkbox.setAttribute("checked", "checked");
      } else {
        checkbox.removeAttribute("checked");
      }
      updateParentSelection(parent, checkbox.checked);
    });
  });

  function updateParentSelection(parent, isChecked) {
    if (isChecked) {
      parent.classList.add("is-selected");
    } else {
      parent.classList.remove("is-selected");
    }
  }
})();
